/**
 * ImagePreviewDialog — full-size lightbox for image attachments. Opened by
 * clicking a thumbnail in the attachment lists (pour wizard staged files and
 * saved pour attachments).
 */
import React from 'react';
import { Box, Dialog, DialogContent, IconButton, Typography } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

interface ImagePreviewDialogProps {
  /** Image URL to show; null/empty closes the dialog. */
  src: string | null;
  /** File name shown in the header. */
  name?: string;
  onClose: () => void;
}

const ImagePreviewDialog: React.FC<ImagePreviewDialogProps> = ({ src, name, onClose }) => (
  <Dialog open={!!src} onClose={onClose} maxWidth="lg">
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pl: 2, pr: 1, py: 1 }}>
      <Typography variant="subtitle2" noWrap sx={{ pr: 2 }}>
        {name}
      </Typography>
      <IconButton onClick={onClose} size="small" aria-label="Close preview">
        <CloseIcon fontSize="small" />
      </IconButton>
    </Box>
    <DialogContent sx={{ p: 0, display: 'flex', justifyContent: 'center', backgroundColor: 'grey.900' }}>
      {src && (
        <Box
          component="img"
          src={src}
          alt={name || ''}
          sx={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain', display: 'block' }}
        />
      )}
    </DialogContent>
  </Dialog>
);

export default ImagePreviewDialog;
